import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import API_UTIL from '../../services/AuthIntereptor';
import { toast } from 'react-toastify';
import AppBar from '../../components/AppBar/AppBar';
import { Icons, Button } from '../../components/ui';

const Invite = () => {
  const { eventId } = useParams();
  const [event, setEvent] = useState(null);
  const navigate = useNavigate();
  const userPhoneNumber = localStorage?.userPhoneNumber;

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const response = await API_UTIL.get(`/getEventDetails/${eventId}`);
        setEvent(response.data);
      } catch (error) {
        console.error('Error fetching event data:', error);
        toast.error('Failed to fetch event details.');
      }
    };

    fetchEventData();
  }, [eventId]);

  const handleResponse = async (response) => {
    if (response === 'no') {
      navigate('/event');
    } else {
      try {
        // Call the API to map the user to the event
        const apiResponse = await API_UTIL.post('/mapUserToEvent', {
          event_id: event.folder_name,
          user_phone_number: userPhoneNumber
        });

        if (apiResponse.status === 200) {
          toast.success('Event attendance confirmed.');
          navigate('/event');
        }
      } catch (error) {
        console.error('Error confirming event attendance:', error);
        toast.error('Failed to confirm attendance. Please try again.');
      }
    }
  };

  if (!event) {
    return (
      <>
        <AppBar />
        <div className="min-h-[60vh] grid place-items-center text-slate-500 text-sm">Loading...</div>
      </>
    );
  }

  return (
    <>
      <AppBar />
      <div className="fade-in max-w-md mx-auto px-4 sm:px-6 py-12">
        <div className="bg-white border border-gray-200 rounded-2xl shadow-card p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-brand-50 border border-brand-100 text-brand-600 grid place-items-center mx-auto">
            <Icons.Calendar className="w-7 h-7" />
          </div>
          <h1 className="mt-5 text-xl font-bold text-slate-900">Event Invitation</h1>
          <p className="mt-2 text-slate-500 leading-relaxed">
            Are you attending the event:{' '}
            <span className="font-medium text-slate-700">{event.event_name}</span>?
          </p>

          <div className="mt-6 flex items-center justify-center gap-3">
            <Button onClick={() => handleResponse('yes')} icon={Icons.Check}>
              Yes
            </Button>
            <Button variant="secondary" onClick={() => handleResponse('no')} icon={Icons.X}>
              No
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Invite;
